import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterRoutingModule } from './register-routing.module';
import { RegisterComponent } from './pages/register/register.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderRegisterComponent } from './components/header-register/header-register.component';
import { SkeletonFooterRegisterComponent } from './components/skeleton-footer-register/skeleton-footer-register.component';
import { SkeletonRegisterComponent } from './components/skeleton-register/skeleton-register.component';
import { SocialComponent } from './pages/social/social.component';
import { HeaderSocialComponent } from './components/header-social/header-social.component';

@NgModule({
    declarations: [
        RegisterComponent,
        HeaderRegisterComponent,
        SkeletonFooterRegisterComponent,
        SkeletonRegisterComponent,
        SocialComponent,
        HeaderSocialComponent,
    ],
    imports: [
        CommonModule,
        RegisterRoutingModule,
        IonicModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
    ],
})
export class RegisterModule {}
